export default "__VITE_ASSET__c5d63c77__"